import { PurchData, SalesData } from './format';
import { Empty } from './kpi';

export function VendorTable({ rows, M }: { rows: PurchData['vendors']; M: (n: number) => string }) {
  if (!rows.length) return <Empty />;
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-body">
        <thead><tr className="text-secondary text-left border-b border-border-light">
          <th className="py-1.5 font-medium">Vendor</th><th className="py-1.5 font-medium text-right">Total</th><th className="py-1.5 font-medium text-right">POs</th><th className="py-1.5 font-medium text-right">Avg PO</th><th className="py-1.5 font-medium text-right">Received</th>
        </tr></thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className="border-b border-border-light/60">
              <td className="py-1.5 text-primary-text truncate max-w-[160px]">{r.name}</td>
              <td className="py-1.5 text-right font-numeric tabular-nums">{M(r.total)}</td>
              <td className="py-1.5 text-right font-numeric tabular-nums text-secondary">{r.pos}</td>
              <td className="py-1.5 text-right font-numeric tabular-nums text-secondary">{M(r.avg_po)}</td>
              <td className="py-1.5 text-right font-numeric tabular-nums">{r.received_pct}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
export function StatusTable({ rows, M }: { rows: SalesData['by_status']; M: (n: number) => string }) {
  if (!rows.length) return <Empty />;
  return (
    <table className="w-full text-body">
      <thead><tr className="text-secondary text-left border-b border-border-light"><th className="py-1.5 font-medium">Status</th><th className="py-1.5 font-medium text-right">Orders</th><th className="py-1.5 font-medium text-right">Value</th></tr></thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.status} className="border-b border-border-light/60">
            <td className="py-1.5 text-primary-text capitalize">{r.status}</td>
            <td className="py-1.5 text-right font-numeric tabular-nums text-secondary">{r.n}</td>
            <td className="py-1.5 text-right font-numeric tabular-nums">{M(r.value)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
export function DetailTable({ cols, rows }: { cols: string[]; rows: string[][] }) {
  if (!rows.length) return <Empty />;
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-body">
        <thead><tr className="text-secondary text-left border-b border-border-light">
          {cols.map((c, i) => <th key={c} className={`py-1.5 font-medium ${i === 0 ? '' : 'text-right'}`}>{c}</th>)}
        </tr></thead>
        <tbody>
          {rows.map((r, ri) => (
            <tr key={ri} className="border-b border-border-light/60">
              {r.map((cell, ci) => <td key={ci} className={`py-1.5 ${ci === 0 ? 'text-primary-text truncate max-w-[200px]' : 'text-right font-numeric tabular-nums'}`}>{cell}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
